import { render } from "./meta.vue?vue&type=template&id=2fca3ea5&scoped=true"
import script from "./meta.vue?vue&type=script&lang=js"
export * from "./meta.vue?vue&type=script&lang=js"

import "./meta.vue?vue&type=style&index=0&id=2fca3ea5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fca3ea5"]])

export default __exports__